import type { Hit } from "@opensearch-project/opensearch/api/_types/_core.search";

function mapProductSearchHits<T>(
    hits: Hit[] | undefined,
    mapSource: (source: Record<string, unknown>) => T | null,
): T[] {
    return (hits ?? [])
        .map(hit => {
            const source = hit?._source;
            const record =
                source && typeof source === "object" && !Array.isArray(source)
                    ? (source as Record<string, unknown>)
                    : {};
            return mapSource(record);
        })
        .filter((item): item is T => item != null);
}

export { mapProductSearchHits };
